var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgBroadcast = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Broadcast1_"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Broadcast1_",
    "data-name": "Broadcast1 ",
    clipPath: "url(#clip-Broadcast1_)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(-155.842 -58.735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21183",
    "data-name": "Path 21183",
    d: "M169.1,65.023l-.687-.446a3.637,3.637,0,0,0-1.1-5.09l.446-.687a4.452,4.452,0,0,1,1.337,6.223Zm-2.118-.78-.576-.446a2.008,2.008,0,0,0-.613-2.824l.334-.687a2.822,2.822,0,0,1,.855,3.957Zm-1.969-.78a1.189,1.189,0,0,0-.353-1.69l.279-.409a1.66,1.66,0,0,1,.5,2.378ZM166.7,73.1c.037.2.111.409-.223.5a.511.511,0,0,1-.334,0,.446.446,0,0,1-.13-.056l-2.563-2.043-2.6,2.062a.1.1,0,0,1-.074.037.45.45,0,0,1-.39.037c-.334-.111-.26-.3-.223-.5l2.656-9.734a.815.815,0,0,1-.242-.576.8.8,0,0,1,1.6,0,.775.775,0,0,1-.13.427ZM164.346,67.7l-.594.52.947.836Zm1.337,4.9-.65-2.378-1.152.91Zm-4.477.019,1.82-1.467-1.152-.929Zm2.248-1.839,1.356-1.115-1.375-1.207-1.356,1.189Zm-1.282-1.709.984-.855-.594-.52Zm.5-1.8.78.687.762-.669-.019-.056-.743-.724-.762.724Zm.167-.576.409-.39-.242-.242Zm.613-2.266-.353,1.319.371.353.353-.334Zm.446,1.653-.242.223.39.371Zm-2.285-2.563-.427.26a1.694,1.694,0,0,1,.5-2.378l.279.409a1.213,1.213,0,0,0-.353,1.709Zm-1.375.334-.557.446a2.855,2.855,0,0,1,.836-3.975l.334.687a2.032,2.032,0,0,0-.613,2.842Zm-1.969.8-.687.446a4.515,4.515,0,0,1,1.3-6.26l.446.687a3.687,3.687,0,0,0-1.059,5.127Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.11,
    fillRule: "evenodd"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBroadcast, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Broadcast.47270eaa.svg";
export { ForwardRef as ReactComponent };